import { render, staticRenderFns } from "./TreeNodeDocPackage.vue?vue&type=template&id=25e497b6&"
import script from "./TreeNodeDocPackage.vue?vue&type=script&lang=js&"
export * from "./TreeNodeDocPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports